import React from "react";
import styled from "styled-components";
import theme from "theme";
import { intentRamps, sectionIds } from "content/site";
import {
	Container,
	Section,
	SectionTitle,
	SectionLead,
	TextLink,
	MarketingCard,
} from "components/marketing/primitives";

const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
	gap: 1.35rem;
`;

const CardTitle = styled.h3`
	font-family: ${theme.fontFamily.sans};
	font-size: 1.125rem;
	font-weight: 800;
	margin: 0 0 0.5rem;
	color: ${theme.color.dark};
	letter-spacing: -0.02em;
`;

const CardBody = styled.p`
	font-family: ${theme.fontFamily.sans};
	font-size: 0.9375rem;
	color: ${theme.color.greyD2};
	margin: 0 0 1rem;
	line-height: 1.55;
	flex: 1;
`;

export default function IntentRamps() {
	return (
		<Section id={sectionIds.intent} aria-labelledby="intent-heading">
			<Container>
				<SectionTitle id="intent-heading">Pick your path</SectionTitle>
				<SectionLead>
					Choose how you want to work with Truss — explore, integrate, operate, or join the community.
				</SectionLead>
				<Grid>
					{intentRamps.map((r) => (
						<MarketingCard key={r.id}>
							<CardTitle>{r.title}</CardTitle>
							<CardBody>{r.description}</CardBody>
							<TextLink href={r.href}>{r.linkLabel} →</TextLink>
						</MarketingCard>
					))}
				</Grid>
			</Container>
		</Section>
	);
}
